import { EventPageFragment } from '@graphql/generated';
import { useOnIntersectingChange } from '@shared/utils/hooks/useOnIntersectingChange';
import { RefObject, useCallback, useContext } from 'react';
import { useHistory, useParams } from '@react-router';
import { debounce } from 'lodash-es';
import { AuxFrameContext } from '../components/AuxFrame';
import { useScrollToRef } from './useScrollToRef';
import { useScrollTo } from '../providers/ScrollToProvider/ScrollTo.context';
import { useFeatureValue } from '@shared/core/featureFlags';
import { isInIframe } from '@shared/utils/isInIframe';

export const useAlohaScrollWatch = (pageRef: RefObject<HTMLElement>, page?: Maybe<EventPageFragment>) => {
  const history = useHistory();
  const { hackySolution } = useScrollTo();
  const isScrollbarV2Enabled = useFeatureValue('enableScrollbarV2');
  const params = useParams<{ eventHandle: string }>();
  // change the aux panel panel image
  const { setPageInView, page: currentPage } = useContext(AuxFrameContext);
  useScrollToRef(pageRef, page?.id);
  const isPreviewing = isInIframe();

  // detect when page comes into view from the bottom
  // and update location for appropriate page slug
  // this 'hacky' way is still needed for the photo to update on scroll in the case of previewing aloha
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onIntersection = useCallback(
    debounce(
      (isIntersecting: boolean) => {
        if (isScrollbarV2Enabled && !isPreviewing) return;
        if (isIntersecting) {
          setPageInView(page?.pageSlug ?? ' ');
          if (page?.pageSlug) {
            hackySolution(`/${params.eventHandle}/${page?.pageSlug}`);
          }
        }
      },
      250,
      { maxWait: 1000 }
    ),
    [history, page?.pageSlug, params.eventHandle, isScrollbarV2Enabled]
  );
  useOnIntersectingChange(pageRef, onIntersection);
  return { currentPage };
};
